import { Grid, Typography, Button, Chip, Badge, Divider, Paper, Stack, Tooltip } from "@mui/material";
import { Done, Clear } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import moment from "moment";

export default function OperatorRequestCard(props) {
  const isEwoButtonEnabled = (row) => {
    if (row.emergencyWorkOrderId) {
      return false;
    } else if (!row.createdDate) {
      return false;
    } else return true;
  };

  const canCancelTask = (row) => {
    if (props.canCancelAnyTask) {
      return true;
    }

    const creatorCandidates = [row.creatorId, row.creatorCode, row.createdBy, row.creatorName, row.createdByName];
    const currentUserId = Number(props.currentUserId);
    const currentUserCode = props.currentUserCode?.toString();
    const currentUserName = props.currentUserName?.toString();

    return creatorCandidates.some((creator) => {
      if (creator === null || creator === undefined) {
        return false;
      }
      const creatorString = creator.toString();
      const creatorNumber = Number(creatorString);
      if (!Number.isNaN(creatorNumber) && creatorNumber === currentUserId) {
        return true;
      }
      return creatorString === currentUserCode || creatorString === currentUserName;
    });
  };

  const { t } = useTranslation("translation");

  const isEwoPlant = (row) => {
    const validCodes = ["Lipetsk IHPA REF", "Lipetsk IHPA WM", "MBI"];
    const validIds = [1078, 1079, 1080, 1081, 1082, 1083,46,47,48,49,50,51];

    return validCodes.includes(row.plantCode) || validIds.includes(row.plantId);
  };
  return (
    <Paper
      sx={{
        m: 1,
        p: 2,
        borderRadius: 2,
        backgroundColor: "#ffffff",
        boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
        overflow: "hidden",
        position: "relative",
        minHeight: "240px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        "&:before": {
          content: '""',
          position: "absolute",
          width: "5px",
          height: "100%",
          backgroundColor: props.HandleColor(props.row),
          left: 0,
          top: 0,
        },
      }}
    >
      {/* Sol üst köşede sarkan Chip */}
      <Chip
        label={props.row.priority}
        sx={{
          backgroundColor: props.HandleColor(props.row),
          color: "#fff",
          fontWeight: "bold",
          fontSize: "14px",
          px: 0.1,
          py: 0.1,
          borderRadius: "8px",
          position: "absolute",
          top: -7,
          left: 10,
          zIndex: 1,
        }}
      />
      <Grid container spacing={2} alignItems="center">
        {/* Ekipman Bilgileri Üst Kısım */}
        <Grid item xs={12} textAlign="center">
          <Typography variant="subtitle1" fontWeight="bold" sx={{ color: "#37474f" }}>
            {props.row.equipmentCode}
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {props.row.equipmentName}
          </Typography>
          <Divider sx={{ my: 1 }} />
          <Grid container spacing={1} sx={{ textAlign: "center" }}>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#424242",
                  fontWeight: "bold",
                  marginRight: "4px",
                }}
              >
                <strong>{t("Task")}:</strong>
              </Typography>
              <Typography variant="body2" sx={{ color: "#424242" }}>
                {props.row.id}
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#424242",
                  fontWeight: "bold",
                  marginRight: "4px",
                }}
              >
                <strong>{t("BreakdownGroup")}:</strong>
              </Typography>
              <Typography variant="body2" sx={{ color: "#424242" }}>
                {props.row.breakdownReasonGroupName}
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#424242",
                  fontWeight: "bold",
                  marginRight: "4px",
                }}
              >
                <strong>{t("Status")}:</strong>
              </Typography>
              <Typography variant="body2" sx={{ color: "#424242" }}>
                {t(props.row.statusDesc)}
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#424242",
                  fontWeight: "bold",
                  marginRight: "4px",
                }}
              >
                <strong>{t("Effect")}:</strong>
              </Typography>
              <Typography variant="body2" sx={{ color: "#424242" }}>
                {props.row.breakdownEffectName}
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#424242",
                  fontWeight: "bold",
                  marginRight: "4px",
                }}
              >
                <strong>{t("CreatedDate")}:</strong>
              </Typography>
              <Typography variant="body2" sx={{ color: "#424242" }}>
                {props.TimeFormat(props.row.createdDate)}
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#424242",
                  fontWeight: "bold",
                  marginRight: "4px",
                }}
              >
                <strong>{t("Note")}:</strong>
              </Typography>
              <Typography variant="body2" sx={{ color: "#424242" }}>
                {props.row.orderNote}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* Sağ Kısım: Butonlar */}
        <Grid item xs={12}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
            sx={{
              gap: "2px",
            }}
          >
            {props.row.taskStatus === 1 && canCancelTask(props.row) ? (
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#d32f2f", // Kırmızı
                  color: "#fff",
                  borderRadius: "10px",
                  px: 1.5,
                  py: 0.5,
                  fontSize: "12px",
                  width: { xs: "120px", sm: "150px" }, // Mobilde daha küçük
                  minWidth: "120px", // Mobilde daha küçükg
                  "&:hover": {
                    backgroundColor: "#b71c1c", // Hoverda daha koyu kırmızı
                  },
                }}
                startIcon={<Clear />}
                onClick={() => props.CancelButtonHandler(props.row.maintenanceOrderId)}
              >
                {t("Cancel")}
              </Button>
            ) : props.row.taskStatus === 5 ? (
              <Button
                onClick={() => props.ConfirmButtonHandler(props.row.id)} // taskId
                size="small"
                variant="contained"
                color="success" // Yeşil
                startIcon={<Done />}
                sx={{
                  width: { xs: "120px", sm: "150px" }, // Mobilde daha küçük
                  minWidth: "120px", // Mobilde daha küçük
                  borderRadius: "10px",
                  "&:hover": {
                    backgroundColor: "#388e3c", // Hoverda daha koyu yeşil
                  },
                }}
              >
                {t("Confirm")}
              </Button>
            ) : null}

            {isEwoPlant(props.row) &&
              (!isEwoButtonEnabled(props.row) ? (
                <Tooltip title={t("EwoButtonDisabledReason")}>
                  <span>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#1976d2",
                        color: "#fff",
                        borderRadius: "10px",
                        px: 1.5,
                        py: 0.5,
                        fontSize: "12px",
                        width: { xs: "121px", sm: "150px" },
                        minWidth: "120px",
                        "&:hover": {
                          backgroundColor: "#1565c0",
                        },
                      }}
                      disabled
                      onClick={() => props.CreateEwoForm(props.row)}
                      color="inherit"
                    >
                      {t("AddEwoForm")}
                    </Button>
                  </span>
                </Tooltip>
              ) : (
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#1976d2",
                    color: "#fff",
                    borderRadius: "10px",
                    px: 1.5,
                    py: 0.5,
                    fontSize: "12px",
                    width: { xs: "121px", sm: "150px" },
                    minWidth: "120px",
                    "&:hover": {
                      backgroundColor: "#1565c0",
                    },
                  }}
                  onClick={() => props.CreateEwoForm(props.row)}
                  color="primary"
                >
                  {t("AddEwoForm")}
                </Button>
              ))}
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
}
